import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { AlertWarningCircleIcon } from '@calendly/ui/components/icons';
import { errorColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledLogoCss = "swagvlv";
const StyledLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} className={classNames(styledLogoCss, props.className)} />);
const logoNames = {
  gmail: 'gmail',
  outlook: 'microsoft-outlook',
  calendly: 'calendly'
};
export const SendFromOptionIcon = ({
  option
}) => {
  if (!option.type) return null;
  if (option.accessGranted) {
    return <StyledLogo name={logoNames[option.type]} />;
  }
  return <AlertWarningCircleIcon size="standard" color={errorColor} />;
};

require("./send_from_option_icon.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send_from_option_icon.js");